import Home from "./Home";
import { Routes,Route, useLocation} from "react-router-dom";
import OnlineRadio from "./OnlineRadio";
import { useContext, useEffect, useState } from "react";
import { realtimeDB } from "./Backend";
import { ref, remove } from "firebase/database";
import Admindashboard from "./Admindashboard";
import About from "./About";
import AuthUser from "./newComponent/AuthUser";
import Reportform from "./newComponent/Reportform";
import ChapterDashb from "./newComponent/ChapterDashb";
import Adminreportdashb from "./Adminreportdashb";
import Testimonyblogs from "./newComponent/Testimonyblogs";
import SharedTestimony from "./newComponent/SharedTestimony";
import ChapterTuts from "./newComponent/ChapterTuts";
import UnitTuts from "./newComponent/UnitTuts";
import TutorialPlayer from "./newComponent/Tutplayer";
import Notfoundpage from "./NotFoundpage";
import VideoCarousel from "./VideoCarousel";
// import ProducerVideo from "./webRtc/producer";
import { DataContext } from "./DataContextProvider";
import VideoConference from "./webRtc/videoConfRoom";

function App() {
  
  const location = useLocation();
  const {userID} = useContext(DataContext);
  const [accessReport,setaccessReport]=useState(false);
 
  

  const trackAccessToken=(tokenstate)=>{
    if(tokenstate === "verified"){
      setaccessReport(true);
    }else{
      setaccessReport(false);
    }
  };


  useEffect(()=>{
    if(location.pathname === "/"){
          if(userID !== ""){
            try{
              remove(ref(realtimeDB,`users/${userID}`));
              remove(ref(realtimeDB,`zionusers/${userID}`));
            }catch{

            }
         
          }else{
            try{
              remove(ref(realtimeDB,`users/${localStorage.getItem("user_id")}`));
              remove(ref(realtimeDB,`zionusers/${localStorage.getItem("user_id")}`));
            }catch{

            }
          }
    }
  },[userID,location]);

  return (
    <div className="App">
        <Routes>
          <Route path="/">
          <Route index element = {<Home/>}/>
          <Route path="onlineradio" element = {<OnlineRadio/>}/>
          {/* <Route path="horemowghlive" element = {<ViewLiveVideo/>}/> */}
          <Route path="admindashboard" element = {<Admindashboard/>}/>
          <Route path="about" element = {<About/>}/>
          <Route path="report/auth" element = {<AuthUser tokenvalue={trackAccessToken}/>}/>
          <Route path="report/form" element = {accessReport && <Reportform/>}/>
          <Route path="chapter_dashboard/:name" element = {accessReport && <ChapterDashb tokenvalue={trackAccessToken}/>}/>
          <Route path="reportingdashboard" element = {<Adminreportdashb/>}/>
          <Route path="testimonies" element = {<Testimonyblogs/>}/>
          <Route path="testimonies/:name/:id" element = {<SharedTestimony/>}/>
          <Route path="chaptertutorials" element = {<ChapterTuts/>}/>
          <Route path="unittutorials" element = {<UnitTuts/>}/>
          <Route path="hghrptplayer/:tuts/:name/:id" element = {<TutorialPlayer/>}/>
          <Route path="horemowghvideos" element = {<VideoCarousel/>}/>
          {/* <Route path="bethelcastproducer" element = {<ProducerVideo/>}/> */}
          <Route path="bethelcast" element = {<VideoConference/>}/>
          <Route path='*' element = {<Notfoundpage/>} />
          </Route>
        </Routes>
    </div>
  );
}
export default App;